<template>
  <div class="image-input-wrap">
    <label class="label">{{label}}</label>
    <div class="image-input" @click="pick">
      <tk-image v-if="url" :src="url" height="176"></tk-image>
      <div v-if="!url" class="empty">
        <v-icon>cloud_upload</v-icon>
        <br/>
        <span>选择一张图片</span>
      </div>
      <div class="edit" v-else>
        <v-btn icon @click.native.stop="open" dark><v-icon>open_in_new</v-icon></v-btn>
        <v-btn icon @click.native.stop="remove" v-if="!disabled" dark><v-icon>clear</v-icon></v-btn>
      </div>
    </div>
    <div v-show="error" class="input-error">{{error}}</div>
  </div>
</template>
<script>
export default {
  name: 'image-input',
  data: function () {
    return {
      preview: ''
    }
  },
  computed: {
    compressUrl () {
      return this.url ? this.url + '?x-oss-process=image/resize,h_180' : ''
    },
    url () {
      return this.preview ? this.preview : this.value
    }
  },
  methods: {
    pick (e) {
      if (this.disabled) return
      this.$tkFile.pick({
        type: 'image'
      }).then((file) => {
        this.preview = file.url
        this.upload(file)
      })
    },
    upload (file) {
      if (this.useParse) {
        this.$tkParse.post('/files', file.buffer).then((rs) => {
          this.$emit('input', rs.data.url)
        }).catch(() => {
          this.preview = ''
          this.$tkGlobal.alert.show('文件上传失败')
        })
      } else {
        let data = this.$tkFile.createFormData({
          file: file
        })
        this.$apiAjax.post('/file', data).then((rs) => {
          this.$emit('input', rs.data.url)
        }).catch(e => {
          this.preview = ''
          this.$tkGlobal.alert.show('文件上传失败')
        })
      }
    },
    open () {
      window.open(this.url)
    },
    remove () {
      this.preview = ''
      this.$emit('input', '')
    }
  },
  props: {
    value: String,
    label: String,
    error: String,
    disabled: Boolean,
    useParse: {
      type: Boolean,
      default: true
    }
  }
}
</script>
<style lang="scss" scoped>
  label {
    color: rgba(0, 0, 0, 0.54);
    margin-bottom: 4px;
    display: block;
    font-size: 16px;
  }
  .image-input-wrap {
    width: 100%;
    margin-bottom: 12px;
    overflow: hidden;
    position: relative;
  }
  .image-input {
    cursor: pointer;
    width: 100%;
    height: 180px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    background-size: contain;
    background-position: center;
    border: 1px solid rgba(0,0,0,.12);
    position: relative;

    .empty{
      text-align: center;
      color: rgba(0, 0, 0, 0.54);
    }
    .edit{
      position: absolute;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: flex-start;
      justify-content: flex-end;
      background-color: rgba(0, 0, 0, 0.54);
      opacity: 0;
    }
    &:hover .edit {
      opacity: 1;
    }
  }
</style>
